import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  serviceMappingSuccessTitle: {
    defaultMessage: 'Service Mapping Updated',
    description: 'service mapping success notification message title',
    id: 'dSapk6',
  },
  serviceMappingSuccessContent: {
    defaultMessage: 'Your service mapping has been successfully updated.',
    description: 'service mapping success notification message content',
    id: 'n5zdfn',
  },
  serviceMappingDeletedTitle: {
    defaultMessage: 'Service Mapping Deleted',
    description: 'service mapping deleted notification message title',
    id: '+Sd4fJ',
  },
  serviceMappingDeletedContent: {
    defaultMessage: 'Your service mapping has been deleted.',
    description: 'service mapping deleted notification message content',
    id: 'EeNIWB',
  },
  serviceMappingErrorTitle: {
    defaultMessage: 'Unable to update Service Mapping',
    description: 'service mapping error notification message title',
    id: 'NecScr',
  },
  serviceMappingErrorContent: {
    defaultMessage: 'There was an error updating your service mapping, please try again later.',
    description: 'service mapping error notification message content',
    id: 'yJKvqj',
  },
});
